<template>
    <div id="content">
        <router-link :to="`/plans/${plan.id}`" class="back-link"><i class="bi bi-chevron-left"></i> {{ $t('plans.planModules.back') }}</router-link>

        <div class="admin-card plan-head">
            <div class="plan-head-main">
                <div class="admin-section-label">
                    <i class="bi bi-piggy-bank"></i>
                    {{ $t('plans.planModules.planLabel') }}
                </div>
                <h1 class="plan-name">{{ plan.title }}</h1>
                <h3 class="plan-price text-gradient">{{ price }} ₸ / {{ cycles[plan.cycle - 1] }}</h3>
            </div>
        </div>

        <div class="admin-card modules-card mt-4">
            <div class="admin-section-label">
                <i class="bi bi-diagram-2"></i>
                {{ $t('plans.planModules.title') }}
            </div>
            <div class="modules-list">
                <div v-for="(m, index) in modules" :key="m.id" class="module-row">
                    <div class="module-row-main">
                        <div class="module-row-name">{{ m.name }}</div>
                        <div class="module-row-desc">{{ m.description }}</div>
                    </div>
                    <div class="module-row-controls">
                        <div class="form-check form-switch m-0">
                            <input
                                v-model="modules[index].status"
                                class="form-check-input"
                                type="checkbox"
                                role="switch"
                                @change="switchModule(m.id)"
                            >
                        </div>
                        <router-link :to="`/plans/${plan.id}/modules/${m.slug}`" class="module-row-edit" :title="$t('plans.planModules.configure')">
                            <i class="bi bi-pencil"></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { cycles, tsToString } from '../../../lib/utils'

export default {
    data:() => ({
        plan: {},
        modules: [],
        cycles: cycles.map(c => c.text),
        price: 0,
        startDate: '',
        endDate: ''
    }),
    async mounted() {
        this.$emit('setPageTitle', this.$t('plans.planModules.title'))

        await this.getPlan()
        this.modules = await this.getModules()
    },
    methods: {
        async getPlan() {
            let res = await this.$api.getPlan(this.$route.params.id)
            if(res.result === 'ERROR') {
                this.$notify({
                    text: res.msg,
                    type: res.result.toLowerCase()
                })
                this.$router.push('/plans')
            } else {
                this.plan = res.data
                this.price = this.plan.price.toLocaleString()
            }
        },
        async getModules() {
            let r = await this.$api.getPlanModules(this.plan.id)
            if(r.result === 'SUCCESS') {
                return r.data
            } else {
                this.$notify({
                    text: r.msg,
                    type: r.result.toLowerCase()
                })
                return []
            }
        },
        async switchModule(moduleId) {
            let response = await this.$api.switchModule(this.plan.id, moduleId)

            this.$notify({
                text: response.msg,
                type: response.result.toLowerCase()
            })
        }
    }
}
</script>

<style scoped>
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 14px;
    transition: color 0.15s ease;
}
.back-link:hover {
    color: #6d28d9;
}
.back-link i {
    font-size: 14px;
}

.plan-head {
    padding: 24px;
}

.plan-head-main {
    flex: 1;
}

.plan-name {
    font-size: 26px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 4px 0;
    letter-spacing: -0.01em;
}

.plan-price {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    width: fit-content;
}

.modules-card {
    padding: 24px;
}

.modules-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.module-row {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px 16px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    transition: border-color 0.15s ease, background 0.15s ease;
}

.module-row:hover {
    border-color: #c4b5fd;
    background: #fafbfc;
}

.module-row-main {
    flex: 1;
    min-width: 0;
}

.module-row-name {
    font-size: 14px;
    font-weight: 600;
    color: #0f172a;
    margin-bottom: 2px;
}

.module-row-desc {
    font-size: 13px;
    color: #64748b;
}

.module-row-controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.module-row-edit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #f1f5f9;
    color: #475569;
    text-decoration: none;
    transition: background 0.15s ease, color 0.15s ease;
}
.module-row-edit:hover {
    background: #ede9fe;
    color: #6d28d9;
}

.form-switch .form-check-input {
    width: 3em;
    height: 1.5em;
}
</style>
